let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2IxWW")).then(() => parcelRequire('iM8xS'));